import { render, staticRenderFns } from "./registration-card.vue?vue&type=template&id=63d3c5d5&scoped=true"
import script from "./registration-card.vue?vue&type=script&lang=js"
export * from "./registration-card.vue?vue&type=script&lang=js"
import style0 from "./registration-card.vue?vue&type=style&index=0&id=63d3c5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3c5d5",
  null
  
)

export default component.exports